import React from "react";
import styled from "styled-components";
import TitleSvg from "../img/title-theme.svg";
import device from "../helpers/device";

export default function TextBlock({ ...props }) {
  return (
    <Wrapper {...props}>
      <Title>
        <img src={TitleSvg} alt="THEME CONNECT + CREATE" />
      </Title>
      <Text>
        <p>
          昨年1,000人以上の技術者が参加した全社技術カンファレンス「CA BASE
          CAMP」
        </p>
        <p>第2回目となる今回のコンセプトは「CONNECT ＋ CREATE」</p>
        <p>
          エンジニア・クリエイターという職種の壁はもちろん、所属の壁を超えて繋がることで、また新たな価値を生み出して欲しい想いで開催します。
        </p>
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 40px;
  @media ${device.mobileL} {
    padding-top: 100px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin: 0 auto 20px auto;
  width: 66%;
  @media ${device.mobileL} {
    width: 366px;
    margin: 0 auto 60px auto;
  }
  > img {
    width: 100%;
  }
`;

const Text = styled.div`
  line-height: 2;
  width: 90%;
  margin: 0 auto;
  @media ${device.mobileL} {
    text-align: center;
    width: 600px;
  }
`;
